/**
 * O "Exportar" dos relatórios (08/10/2026): baixa o que a tela mostra numa
 * planilha que o Excel abre. O conteúdo de cada uma está em `planilhas.ts`.
 *
 * Fica nas ações do cabeçalho, que não rola: é onde a pessoa procura o que
 * fazer com a tela inteira, e não com um cartão.
 */

import type { ReactNode } from 'react';
import { Botao, Icone } from '@/shared/ui';
import { baixar } from '@/shared/lib/planilha';
import { type Tabela } from '@/shared/lib/planilha';

export function BotaoExportar({
  planilha,
}: {
  /**
   * O conteúdo e o nome do arquivo, ou `null` enquanto os números não chegaram.
   * Uma função, e não a tabela pronta: a planilha só é montada no clique.
   */
  planilha: (() => { conteudo: Tabela; nome: string }) | null;
}): ReactNode {
  return (
    <Botao
      variante="secundario"
      desabilitado={planilha === null}
      motivo="Os números ainda não chegaram."
      title="Baixa os números desta tela numa planilha do Excel"
      onClick={() => {
        if (!planilha) return;
        const { conteudo, nome } = planilha();
        // A aba leva o nome do relatório, que é o valor da primeira linha
        // ("Relatório", "Ranking de vendas") de toda planilha de `planilhas.ts`.
        const relatorio = conteudo[0]?.[1];
        baixar(conteudo, nome, typeof relatorio === 'string' ? relatorio : 'Relatório');
      }}
    >
      <Icone nome="planilha" />
      Exportar
    </Botao>
  );
}
